module.exports = __webpack_public_path__ + "dojo-toolkit-white-bg.lzwxB5qx.png";